module.exports = __webpack_public_path__ + "7a193b6b58e81d0cae2557bf7675524a.png";